<div class="container-fluid container-fluid--dashboard">
  <span class="d-none">{{ 'detail_status' | label : 'general' | async }}</span>

  <div *ngIf="!loading">
    <div class="mb-5">
      <!--HEADER-->
      <ul class="list-group list-group-flush">
        <li class="list-group-item">
          <div class="d-flex align-items-center participants--table header">
            <i class="me-4 far fa-fw cursor-pointer" (click)="collapseAll()" [ngClass]="allCollapsed ? 'fa-minus-square' : 'fa-plus-square'"></i>
            <div class="participant-name" style="cursor: pointer" (click)="changeSort(1)">
              {{ 'name' | label : 'general' | async }}
              <i
                class="fas"
                [ngClass]="{
                  'fa-sort-up': sort.column == 1 && sort.dir,
                  'fa-sort-down': sort.column == 1 && !sort.dir,
                  'fa-sort': sort.column != 1
                }"
              ></i>
            </div>

            <div class="participant-status" style="cursor: pointer" (click)="changeSort(2)">
              {{ 'status' | label : 'general' | async }}
              <i
                class="fas"
                [ngClass]="{
                  'fa-sort-up': sort.column == 2 && sort.dir,
                  'fa-sort-down': sort.column == 2 && !sort.dir,
                  'fa-sort': sort.column != 2
                }"
              ></i>
            </div>
            <div class="participant-invitedate" style="cursor: pointer" (click)="changeSort(3)">
              {{ 'SubscriptionDate' | label : 'LMS' | async }}
              <i
                class="fas"
                [ngClass]="{
                  'fa-sort-up': sort.column == 3 && sort.dir,
                  'fa-sort-down': sort.column == 3 && !sort.dir,
                  'fa-sort': sort.column != 3
                }"
              ></i>
            </div>
            <div class="participant-finishdate" style="cursor: pointer" (click)="changeSort(4)">
              <div *ngIf="studentsFiltered.length && studentsFiltered[0].deadline">{{ 'expirationdate' | label : 'learningpath' | async }}</div>
              <div>
                {{ 'completed_on' | label : 'LMS' | async }}
                <i
                  class="fas"
                  [ngClass]="{
                    'fa-sort-up': sort.column == 4 && sort.dir,
                    'fa-sort-down': sort.column == 4 && !sort.dir,
                    'fa-sort': sort.column != 4
                  }"
                ></i>
              </div>
            </div>
            <div class="">
              {{ 'status_activities' | label : 'LMS' | async }}
            </div>
          </div>
        </li>
        <li class="list-group-item">
          <div class="d-flex align-items-center participants--table header">
            <i class="me-4 far fa-fw cursor-pointer"></i>
            <div class="participant-name" style="padding-right: 10px">
              <input type="search" class="form-control form-control-sm" aria-describedby="employee-search" [(ngModel)]="employeeSearch" (keydown)="iterator()" (keyup)="iterator()" (change)="iterator()" (search)="iterator()" (blur)="iterator()" placeholder="{{ 'employee' | label : 'navigation' | async }}" />
            </div>
            <div class="participant-status" style="padding-right: 10px">
              <select class="form-select form-select-sm" [(ngModel)]="statusSearch" (keydown)="iterator()" (keyup)="iterator()" (change)="iterator()" (blur)="iterator()">
                <option [ngValue]="0">{{ 'all_except_unsubscribed' | label : 'objective_widget' | async }}</option>
                <option [ngValue]="2">{{ getActivityStatusName(1) | label : 'objective_widget' | async }}</option>
                <option [ngValue]="3">{{ getActivityStatusName(2) | label : 'objective_widget' | async }}</option>
                <option [ngValue]="4">{{ getActivityStatusName(3) | label : 'objective_widget' | async }}</option>
                <option [ngValue]="6">{{ getActivityStatusName(4) | label : 'objective_widget' | async }}</option>
              </select>
            </div>
          </div>
        </li>
      </ul>

      <!-- TABLE CONTENT PARTICIPANTS -->
      <ul class="list-group mb-5">
        <li class="list-group-item" *ngIf="studentsFiltered.length == 0">{{ 'no_participants_results' | label : 'learningpath' | async }}</li>
        <ng-container *ngFor="let participant of studentsFiltered">
          <li
            class="list-group-item list-group-item-action"
            [ngClass]="{
              'list-group-item-secondary': participant.collapsed
            }"
          >
            <div>
              <div class="d-flex align-items-center participants--table">
                <i class="me-4 far fa-fw cursor-pointer" (click)="participant.collapsed = !participant.collapsed" [ngClass]="participant.collapsed ? 'fa-minus-square' : 'fa-plus-square'"></i>

                <div class="participant-name d-flex align-items-center" [ngClass]="{ active: participant.collapsed }">
                  <img (click)="navigateToCurrentCoursesProfile(participant)" *ngIf="participant.hasPhoto" class="me-2" [src]="'/api/img/0/' + participant.studentId + '?width=40&square=true' | safe" (error)="setDefaultPic(participant)" />
                  <i *ngIf="!participant.hasPhoto || participant.pictureError" class="me-2 fas fa-user-circle" (click)="navigateToCurrentCoursesProfile(participant)"></i>
                  <div class="participant-name-text" (click)="navigateToCurrentCoursesProfile(participant)">
                    {{ participant.name }}
                  </div>
                </div>
                <div class="participant-status">
                  <span class="badge" [style.backgroundColor]="getStatusClass(participant.learningPathStudentStatus)">
                    {{ getStatusName(participant.learningPathStudentStatus) | label : 'objective_widget' | async }}
                  </span>
                </div>
                <div class="participant-invitedate">
                  {{ participant.inviteDate | employeeDate | async }}
                </div>
                <div class="participant-finishdate">
                  <div *ngIf="participant.deadline"><i class="me-1 fa-fw fas fa-bell" ngbTooltip="{{ 'expirationdate' | label : 'learningpath' | async }}" placement="top" [style.color]="participant.deadline <= today ? '#dc3545' : ''"></i>{{ participant.deadline | employeeDate | async }}</div>
                  <div>
                    <span *ngIf="participant.deadline"><i class="me-1 fa-fw fas fa-flag-checkered" ngbTooltip="{{ 'completed_on' | label : 'LMS' | async }}" placement="top" [style.color]="participant.learningPathStudentStatus != 4 ? '#bfbfbf' : ''"></i></span>
                    {{ participant.finishDate | employeeDate | async }}
                  </div>
                </div>

                <div class="activities-bar" (click)="participant.collapsed = !participant.collapsed">
                  <div class="activities-bar-item" [style.backgroundColor]="getActivityStatusClass(activity.activityStatusId)" ngbTooltip="{{ activity.name }}: {{ getActivityStatusName(activity.activityStatusId) | label : 'objective_widget' | async }}" placement="top" *ngFor="let activity of participant.activities"></div>
                </div>

                <div class="actions ms-auto d-flex align-items-center">
                  <a class="cursor-pointer table-icon-link" *ngIf="canSendReminders && (participant.learningPathStudentStatus == 2 || participant.learningPathStudentStatus == 3)" (click)="sendReminder(participant.learningPathStudentId)" ngbTooltip="{{ 'send_reminder' | label : 'learningpath' | async }}" placement="left">
                    <i class="fa-fw fs-5 fas fa-user-clock accent-icon"></i>
                  </a>
                  <a class="cursor-pointer table-icon-link disabled" *ngIf="!canSendReminders && (participant.learningPathStudentStatus == 2 || participant.learningPathStudentStatus == 3)" disabled ngbTooltip="{{ 'send_reminder_not_possible' | label : 'learningpath' | async }}" placement="left">
                    <i class="fa-fw fs-5 fas fa-user-clock accent-icon"></i>
                  </a>
                  <a class="cursor-pointer table-icon-link" (click)="resumeLearningPath(participant.learningPathStudentId)" ngbTooltip="{{ 'resume_learningpath' | label : 'learningpath' | async }}" placement="left" *ngIf="participant.learningPathStudentStatus == 6">
                    <i class="fa-fw fs-5 fas fa-play accent-icon"></i>
                  </a>
                  <a class="cursor-pointer table-icon-link" (click)="restartLearningPath(participant.learningPathStudentId)" ngbTooltip="{{ 'restart_learningpath' | label : 'learningpath' | async }}" placement="left" *ngIf="participant.learningPathStudentStatus == 6">
                    <i class="fa-fw fs-5 fas fa-redo accent-icon"></i>
                  </a>
                  <a class="table-icon-link" *ngIf="participant.learningPathStudentStatus != 2 && participant.learningPathStudentStatus != 3 && participant.learningPathStudentStatus != 6"><i class="fa-fw fs-5 fas accent-icon"></i></a>
                  <a class="cursor-pointer table-icon-link" (click)="updateStatusLearningPath(participant.learningPathStudentId)" ngbTooltip="{{ 'change_status_to_completed' | label : 'learningpath' | async }}" placement="left" *ngIf="participant.learningPathStudentStatus == 2 || participant.learningPathStudentStatus == 3">
                    <i class="fa-fw fs-5 fas fa-flag-checkered accent-icon"></i>
                  </a>
                  <a class="table-icon-link" *ngIf="participant.learningPathStudentStatus != 2 && participant.learningPathStudentStatus != 3 && participant.learningPathStudentStatus != 6"><i class="fa-fw fs-5 fas accent-icon"></i></a>
                  <a class="cursor-pointer table-icon-link" (click)="unsubscribe(participant.learningPathStudentId)" ngbTooltip="{{ 'unsubscribe' | label : 'learningpath' | async }}" placement="left" *ngIf="participant.learningPathStudentStatus == 2 || participant.learningPathStudentStatus == 3">
                    <i class="fa-fw fs-5 fas fa-user-slash accent-icon"></i>
                  </a>
                  <a class="table-icon-link" *ngIf="participant.learningPathStudentStatus != 2 && participant.learningPathStudentStatus != 3"><i class="fa-fw fs-5 fas accent-icon"></i></a>
                </div>
              </div>
            </div>

            <!--ACTIVITIES-->
            <div class="" [ngbCollapse]="!participant.collapsed" (shown)="resizeFrame()">
              <div class="activities pt-4 pb-2">
                <ul class="list-group">
                  <li class="list-group-item">
                    <div class="d-flex align-items-center participants--table header">
                      <div class="activity-number">#</div>
                      <div class="activity-type-name">
                        {{ 'activity' | label : 'learningpath' | async }}
                      </div>
                      <div class="activity-status">
                        {{ 'status' | label : 'general' | async }}
                      </div>
                      <div class="activity-invitedate">{{ 'started_on' | label : 'LMS' | async }}<br />{{ 'number_of_attempts' | label : 'LMS' | async }}</div>
                      <div class="activity-score-file">{{ 'score' | label : 'general' | async }}<br />{{ 'file' | label : 'general' | async }}</div>
                      <div class="activity-finishdate">{{ 'mandatory' | label : 'learningpath' | async }}?<br />{{ 'completed_on' | label : 'LMS' | async }}</div>
                      <div class="d-flex flex-grow-1">
                        <div class="activity-empcomments">
                          {{ 'comments_employee' | label : 'LMS' | async }}
                        </div>
                        <div class="activity-mgrcomments">
                          {{ 'comments_manager_HR' | label : 'LMS' | async }}
                        </div>
                      </div>
                      <div class="activity-actions"></div>
                    </div>
                  </li>
                  <li class="list-group-item" *ngFor="let activity of participant.activities">
                    <div class="d-flex align-items-center">
                      <div class="activity-number">
                        <span class="">{{ activity.order }}</span>
                      </div>
                      <div class="activity-type-name">
                        <span ngbTooltip="{{ 'course' | label : 'general' | async }}" placement="top" *ngIf="activity.activityTypeId == 1">
                          <i class="me-1 fa-fw fa fa-users"></i>
                        </span>
                        <span ngbTooltip="{{ 'library_item' | label : 'general' | async }}" placement="top" *ngIf="activity.activityTypeId == 2">
                          <i class="me-1 fa-fw fa fa-file-image"></i>
                        </span>
                        <span ngbTooltip="{{ 'knowledge_test' | label : 'general' | async }}" placement="top" *ngIf="activity.activityTypeId == 3">
                          <i class="me-1 fa-fw fas fa-poll"></i>
                        </span>
                        <span ngbTooltip="{{ 'elearning' | label : 'LMS' | async }}" placement="top" *ngIf="activity.activityTypeId == 5">
                          <i class="me-1 fa-fw fa fa-desktop"></i>
                        </span>
                        <span ngbTooltip="{{ 'file_upload_learningpath' | label : 'general' | async }}" placement="top" *ngIf="activity.activityTypeId == 6">
                          <i class="me-1 fa-fw fas fa-file-upload"></i>
                        </span>
                        {{ activity.name }}
                      </div>
                      <div class="activity-status">
                        <span class="badge" [style.backgroundColor]="getActivityStatusClass(activity.activityStatusId)" *ngIf="!activity.editMode || activity.activityStatusId == 3">
                          {{ getActivityStatusName(activity.activityStatusId) | label : 'objective_widget' | async }}
                        </span>
                        <div *ngIf="activity.editMode && activity.activityStatusId != 3">
                          <select class="form-select form-select-sm" [(ngModel)]="activity.newActivityStatusId">
                            <option [ngValue]="1" [disabled]="activity.activityStatusId != 1">
                              {{ getActivityStatusName(1) | label : 'objective_widget' | async }}
                            </option>
                            <option [ngValue]="2" [disabled]="activity.activityStatusId != 2">
                              {{ getActivityStatusName(2) | label : 'objective_widget' | async }}
                            </option>
                            <option [ngValue]="3">{{ getActivityStatusName(3) | label : 'objective_widget' | async }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="activity-invitedate">
                        <div>
                          <i class="me-1 fa-fw fas fa-hourglass-start" ngbTooltip="{{ 'started_on' | label : 'LMS' | async }}" placement="top" [style.color]="activity.activityStatusId == 1 ? '#bfbfbf' : ''"></i>
                          {{ activity.startDate | employeeDate | async }}
                        </div>
                        <div>
                          <i class="me-1 fa-fw fas fa-hashtag" ngbTooltip="{{ 'number_of_attempts' | label : 'LMS' | async }}" placement="top"></i>
                          <span *ngIf="activity.attemptCount != null">{{ activity.attemptCount }}</span>
                          <span *ngIf="activity.attemptCount == null">0</span>
                        </div>
                      </div>
                      <div class="activity-score-file">
                        <div>
                          <i class="me-1 fa-fw fas fa-poll" ngbTooltip="{{ 'knowledge_test' | label : 'general' | async }}" placement="top"></i>
                          <span *ngIf="activity.isTest">
                            <i class="ms-1 fas fa-fw fa-check text-success"></i>
                          </span>
                          <span *ngIf="!activity.isTest">
                            <i class="ms-1 fas fa-fw fa-times text-error"></i>
                          </span>
                        </div>
                        <div *ngIf="!activity.isTest && activity.activityTypeId != 6">
                          <i class="ms-1 fa-fw fas"></i>
                        </div>
                        <div *ngIf="activity.isTest">
                          <i class="me-1 fa-fw fas fa-percentage" ngbTooltip="{{ 'score' | label : 'general' | async }}" placement="top"></i>
                          {{ activity.score }}
                        </div>
                        <div *ngIf="activity.activityTypeId == 6">
                          <div *ngIf="activity.attachments && activity.attachments.length > 0">
                            <button *ngFor="let attachment of activity.attachments; index as attachmentIndex" (click)="downloadAttachment(attachment)" class="btn-link" type="button" style="text-align: left; max-width: 100%" ngbTooltip="{{ attachment.fileName }}" placement="top">
                              <div class="d-flex">
                                <span><i class="me-1 fa-fw fas fa-file-upload"></i></span>
                                <span class="flex-grow-1 ellipsis">{{ attachment.fileName }}</span>
                              </div>
                            </button>
                          </div>
                          <div *ngIf="!activity.attachments || activity.attachments.length == 0">
                            <div class="d-flex">
                              <span><i class="me-1 fa-fw fas fa-file-upload"></i></span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="activity-finishdate">
                        <div>
                          <i class="me-1 fa-fw fas fa-thumbtack" ngbTooltip="{{ 'mandatory' | label : 'learningpath' | async }}?" placement="top"></i>
                          <span *ngIf="activity.mandatory">
                            <i class="ms-1 fas fa-fw fa-check text-success"></i>
                          </span>
                          <span *ngIf="!activity.mandatory">
                            <i class="ms-1 fas fa-fw fa-times text-error"></i>
                          </span>
                        </div>
                        <div>
                          <i class="me-1 fa-fw fas fa-flag-checkered" ngbTooltip="{{ 'completed_on' | label : 'LMS' | async }}" placement="top" [style.color]="activity.activityStatusId != 3 ? '#bfbfbf' : ''"></i>
                          {{ activity.finishedDate | employeeDate | async }}
                        </div>
                      </div>
                      <div class="d-flex flex-grow-1" *ngIf="!activity.editMode">
                        <div class="activity-empcomments">
                          <div class="pre-line" *ngIf="activity.studentComment">
                            {{ activity.studentComment }}
                          </div>
                        </div>
                        <div class="activity-mgrcomments">
                          <div class="pre-line" *ngIf="activity.managerComment">
                            {{ activity.managerComment }}
                          </div>
                        </div>
                      </div>
                      <div class="d-flex flex-grow-1" *ngIf="activity.editMode">
                        <div class="activity-empcomments">
                          <div class="pre-line" *ngIf="activity.studentComment">
                            {{ activity.studentComment }}
                          </div>
                        </div>
                        <div class="activity-mgrcomments">
                          <textarea class="form-control pre-line" rows="3" [(ngModel)]="activity.newManagerComment"></textarea>
                        </div>
                      </div>
                      <div class="activity-actions">
                        <ng-container *ngIf="!activity.editMode">
                          <a class="cursor-pointer table-icon-link" (click)="updateActivity(activity)" ngbTooltip="{{ 'edit' | label : 'general' | async }}" placement="left">
                            <i class="fa-fw fs-5 far fa-edit accent-icon"></i>
                          </a>
                        </ng-container>
                        <ng-container *ngIf="activity.editMode">
                          <a class="cursor-pointer table-icon-link" (click)="saveActivity(activity)" ngbTooltip="{{ 'save' | label : 'general' | async }}" placement="top" container="body">
                            <i class="far fa-fw fa-save fs-5 accent-icon"></i>
                          </a>
                          <a class="cursor-pointer table-icon-link" (click)="cancelActivity(activity)" ngbTooltip="{{ 'cancel' | label : 'general' | async }}" placement="top" container="body">
                            <i class="fas fa-fw fa-times fs-5 delete-icon"></i>
                          </a>
                        </ng-container>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ng-container>
      </ul>
    </div>
  </div>
</div>
